import React, { useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TableWithHeader } from 'dyl-components';

import Toolbar from './subcomponents/Toolbar';
import Table from './subcomponents/Table';

import BulkActionsProvider, { BulkActionsContext } from 'shared/context/BulkActionsProvider';

import productAddonsActions from 'actions/product_addons';

import './index.scss';

const AddonsContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const [, setSelectedAddons, , setAreAddonsInAllPagesSelected] = useContext(BulkActionsContext);

    useEffect(() => {
        const queryParameters = {
            page: 1,
            limit: 25,
            ...Object.fromEntries(params)
        }

        dispatch(productAddonsActions.readAddons(queryParameters));
        setSelectedAddons([]);
        setAreAddonsInAllPagesSelected(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`/settings/product-catalog-quotes-invoices/addons${query_string ? `?${query_string}` : ''}`);
    }

    return (
        <div className='AddonsPage'>
            <TableWithHeader
                header={(
                    <Toolbar />
                )}
                table={(
                    <Table onPageChange={onPageChange} />
                )}
            />
        </div>
    );
}

const Addons = () => {
    return (
        <BulkActionsProvider>
            <AddonsContainer />
        </BulkActionsProvider>
    );
}

export default Addons;
